import { render, staticRenderFns } from "./KnowledgeBase.component.html?vue&type=template&id=00fdfa12&scoped=true&"
import script from "./KnowledgeBase.component.ts?vue&type=script&lang=ts&"
export * from "./KnowledgeBase.component.ts?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBase.component.scss?vue&type=style&index=0&id=00fdfa12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdfa12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VRadio,VRadioGroup,VSpacer})
